import type { Customer } from '../types/customer';

export const customerRowKey = (customer: Customer): string => String(customer.id);

export interface CustomerTotals {
  count: number;
  openBalance: number;
  creditBalance: number;
}

export const computeCustomerTotals = (rows: Customer[]): CustomerTotals => {
  let openBalance = 0;
  let creditBalance = 0;
  for (const row of rows) {
    openBalance += parseFloat(row.balance) || 0;
    creditBalance += parseFloat(row.credit_balance ?? '0') || 0;
  }
  return {
    count: rows.length,
    openBalance,
    creditBalance,
  };
};
